import { TFunction } from 'i18next'

import {
  EquipmentCategory,
  ReservationCalendarMeta,
} from '../../../common/validations/reservationSchema'

// Get translation key for equipment category
// Maps equipment category enum to translation keys like "reservations:equipmentCategories.washing_machine"
export const getEquipmentCategoryTranslationKey = (
  category: EquipmentCategory
): `reservations:equipmentCategories.${EquipmentCategory}` => {
  return `reservations:equipmentCategories.${category}`
}

// Translate equipment category and combine with optional equipment name
const getTranslatedEquipmentName = (
  equipmentCategory: EquipmentCategory,
  equipment: string | null,
  t: TFunction<['reservations']>
): string => {
  const translatedCategory = t(
    getEquipmentCategoryTranslationKey(equipmentCategory)
  )
  const equipmentName = equipment ? ` ${equipment}` : ''
  return `${translatedCategory}${equipmentName}`
}

export const generateReservationLocationName = (
  calendarMeta: ReservationCalendarMeta,
  t: TFunction<['reservations']>
) => {
  const { equipmentCategory, equipment, realPropertyArea } = calendarMeta

  if (equipmentCategory) {
    const translatedEquipment = getTranslatedEquipmentName(
      equipmentCategory,
      equipment,
      t
    )
    return realPropertyArea
      ? `${translatedEquipment} - ${realPropertyArea}`
      : translatedEquipment
  }

  return realPropertyArea || ''
}
